/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import abstractCaseTranslations from "./abstractCaseTranslations";

const pendingCaseTranslations = {
  ...abstractCaseTranslations,
  initialClientDescriptionAndObjectives: {
    stepHeadline: "Beschreibung der Situation",
    mainDescription:
      "Bitte schildern Sie uns hier kurz Ihre Situation und Fragen. Jede relevante Information hilft uns, Ihren Fall besser bearbeiten zu können.",
    label: "Ihre Situation und Fragen",
  },
  refinementAnswers: {
    label: "Ergänzende Informationen",
  },
  loadingScreen: {
    headline: "Vielen Dank für Ihre Angaben",
    text: "Ihr Anliegen wird gerade für die Bearbeitung im passenden Fachbereich vorbereitet. Dies kann bis zu einer Minute dauern. Bitte laden Sie die Seite nicht neu.",
  },
  hardstop: {
    unconfident: {
      stepHeadline: "Zuordnung nicht möglich",
      mainDescription:
        "Trotz Ihrer ausführlichen Angaben konnten wir Ihr Anliegen nicht eindeutig zuordnen. Unser Mandantenservice wurde verständigt und prüft nun Ihren Fall. Danach werden wir zeitnah zur Klärung des Sachverhalts auf Sie zukommen.",
    },
    uncovered: {
      stepHeadline: "Deckung nicht möglich",
      mainDescription:
        "Dieses Rechtsgebiet wird von Ihrem Versicherer leider nicht abgedeckt. Bitte wenden Sie sich für diesen Fall direkt an Ihre Versicherung.",
    },
  },
  coveredMatch: {
    stepHeadline: "Vielen Dank für Ihre Angaben",
    mainDescription: "Wir haben das passende Produkt für Sie angelegt. Bitte füllen Sie jetzt die verbleibende Antragsstrecke aus.",
  },
};

export default pendingCaseTranslations;
